import { Component, Input } from '@angular/core';
import { stripPeriod } from 'src/app/shared';
import { stripHtml } from 'src/app/shared/functions/strip-html';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-empty-state-label',
    template: `
    <div class="tw-flex tw-flex-col tw-items-center">
      @if (icon) {
        <div>
          <mat-icon class="icon-md" [style.color]="iconColor">{{
            icon
          }}</mat-icon>
        </div>
      }
      @if (loader === 'Dot') {
        <div class="dot-loader"></div>
      }
      @if (header && message) {
        <div class="tagline-header app-pb1">{{ header | translation: translationRequest }}</div>
        @if (message) {
          <div class="tagline-message app-pb3">
            {{ message | translation: translationRequest}}
          </div>
        }
        @if (thinMessage) {
          <div class="tagline-message-second app-pb3">
            {{ thinMessage | translation: translationRequest }}
          </div>
        }
      } @else {
        <div class="tagline-header-sm app-pt1 app-pb3 word">
          {{ header | translation: translationRequest }}{{ message | translation: translationRequest }}
        </div>
        @if (thinMessage) {
          <div class="tagline-message-second">
            {{ thinMessage | translation: translationRequest }}
          </div>
        }
      }
      <div>
        <ng-content></ng-content>
      </div>
    </div>
    `,
    styles: [
        `
      .icon-lg {
        font-size: 100px;
        width: 100px;
        height: 100px;
      }

      .icon-md {
        font-size: 60px;
        width: 60px;
        height: 60px;
      }

      .tagline-header {
        font-size: 18px;
        font-weight: bold;
        color: var(--sed-black-80-color);
      }

      .tagline-header-sm {
        font-size: 14px;
        font-weight: bold;
        color: var(--sed-black-80-color);
      }

      .tagline-message {
        color: var(--sed-black-80-color);
      }

      .tagline-message-second {
        color: var(--sed-black-80-color);
        font-weight: normal;
        position: relative;
        top: -20px;
      }


      .dot-loader {
        width: 50px;
        height: 24px;
        background: radial-gradient(circle closest-side, #67707a 90%, #0000) 0%
            50%,
          radial-gradient(circle closest-side, #67707a 90%, #0000) 50% 50%,
          radial-gradient(circle closest-side, #67707a 90%, #0000) 100% 50%;
        background-size: calc(100% / 3) 12px;
        background-repeat: no-repeat;
        animation: d3 1s infinite linear;
      }
      .word {
        white-space: pre-wrap;
        text-align: center;
      }
      @keyframes d3 {
        20% {
          background-position: 0% 0%, 50% 50%, 100% 50%;
        }
        40% {
          background-position: 0% 100%, 50% 0%, 100% 50%;
        }
        60% {
          background-position: 0% 50%, 50% 100%, 100% 0%;
        }
        80% {
          background-position: 0% 50%, 50% 50%, 100% 100%;
        }
      }
    `,
    ],
    standalone: false
})
export class EmptyStateLabelComponent {
  @Input()
  icon: string;

  private _header: string;

  @Input()
  get header(): string {
    return this._header;
  }
  set header(value: string) {
    this._header = stripPeriod(stripHtml(value));
  }

  private _message: string;
  private _noDataThinMessage: string;

  @Input()
  get message(): string {
    return this._message;
  }

  @Input()
  get thinMessage(): string {
    return this._noDataThinMessage;
  }

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  set message(value: string) {
    this._message = stripPeriod(stripHtml(value));
  }

  set thinMessage(value: string) {
    this._noDataThinMessage = stripPeriod(stripHtml(value));
  }

  @Input()
 iconColor = 'var(--sed-black-80-color)';

  @Input()
  loader: EmptyStateLoader;
}

export type EmptyStateLoader = 'Dot';
